import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { TFunctionComponent } from '../../../../../shared/core/infrastructrue/types';
import { InfoWIthTooltip } from '../../../../../shared/core/infrastructrue/ui/InfoWIthTooltip/InfoWIthTooltip';
import { TUserTenantSpecificRolesCheckbox } from '../../../domain/interfaces';

export const UseTenantSpecificRolesCheckbox: TFunctionComponent<TUserTenantSpecificRolesCheckbox> =
  ({
    isApiRequestInProgress,
    handleAddRole,
    handleRemoveRole,
    isEditableByUserPrincipal,
    unifiedRole,
    config,
    availableTenantAgnosticRoles,
    assignedUserTenantSpecificRolesState,
  }) => {
    const [
      assignedUserTenantSpecificRoles,
      updateAssignedUserTenantSpecificRoles,
    ] = assignedUserTenantSpecificRolesState;

    const isNotAvailableAsTenantSpecificRole =
      config.isNotAvailableAsTenantSpecificRole(
        unifiedRole,
        assignedUserTenantSpecificRoles,
        availableTenantAgnosticRoles,
      );

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ManifestUI.Checkbox
          role={'checkbox'}
          aria-label={`role ${unifiedRole.name}`}
          onChange={(isSelected) => {
            const handleUpdateUnifiedRole = isSelected
              ? handleAddRole
              : handleRemoveRole;
            updateAssignedUserTenantSpecificRoles(
              handleUpdateUnifiedRole(
                assignedUserTenantSpecificRoles,
                unifiedRole.id,
              ),
            );
          }}
          isDisabled={
            !isEditableByUserPrincipal ||
            isApiRequestInProgress ||
            !assignedUserTenantSpecificRoles.has(unifiedRole.id) ||
            isNotAvailableAsTenantSpecificRole
          }
          name={unifiedRole.name}
          isSelected={config.isUnifiedRoleAssignedToUser(
            unifiedRole,
            assignedUserTenantSpecificRoles,
          )}
        >
          <ManifestUI.VisuallyHidden>
            {unifiedRole.name}
          </ManifestUI.VisuallyHidden>
        </ManifestUI.Checkbox>
        {isNotAvailableAsTenantSpecificRole && (
          <ManifestUI.Typography variant="subtextBold">
            N/A
          </ManifestUI.Typography>
        )}
        {isNotAvailableAsTenantSpecificRole && (
          <InfoWIthTooltip
            tooltipText={`This tenant doesn't have access to this feature`}
          />
        )}
      </div>
    );
  };
